import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ReconciliationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--reconciliation']}>
    <Route index element={<Index />} />
  </SubRouter>
))
